import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { TableViewOptionsService } from '../../services/table-view-options.service';
import { TableViewService } from '../../services/table-view.service';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-table-view-actions-bar',
	styleUrls: ['./table-view-actions-bar.component.scss'],
	templateUrl: './table-view-actions-bar.component.html',
	standalone: false,
})
export class TableViewActionsBarComponent {
	tableViewOptionsService = inject(TableViewOptionsService);
	tableViewService = inject<TableViewService<any, any>>(TableViewService);

	@Input() showCompactButton = true;
	@Input() showRefreshButton = true;
	@Input() showResetButton = true;

	@Output() resetFilters: EventEmitter<void> = new EventEmitter<void>();
	@Output() reload: EventEmitter<void> = new EventEmitter<void>();

	resetAllFilters(): void {
		this.tableViewService.resetAllFilters();
		this.resetFilters.emit();
	}

	onReload(): void {
		this.tableViewService.simpleRefresh();
		this.reload.emit();
	}
}
